import * as types from './mutation-types'
import router from '@/router'
export default {

    [types.ATTACH_OPTIONS](state, attachOptions) {
        state.attachOptions = attachOptions
    },
    [types.DOCUMENT_TYPES](state, documentTypes) {
        state.documentTypes = documentTypes
    },
    [types.DELETE_DOCUMENT_TYPE](state, id) {
        let pos = state.documentTypes.findIndex(documentType => documentType.id === id)
        state.documentTypes.splice(pos, 1)
    },

    [types.ADD_DOCUMENT_TYPE](state, data) {
        state.documentTypes.push(data.documentType)
    },

    [types.UPDATE_DOCUMENT_TYPE](state, data) {
        let pos = state.documentTypes.findIndex(documentType => documentType.id === data.documentType.id)
        Object.assign(state.documentTypes[pos], { ...data.documentType })
    },


    //invoice Attachment data
    [types.BOOTSTRAP_INVOICE_DOCUMENTTYPES](state, invoiceDocumentTypes) {
        state.invoiceDocumentTypes = invoiceDocumentTypes
    },
    [types.ATTACHMENTS](state, attachments) {
        state.attachments = attachments
    },
    [types.SET_TOTAL_ATTACHMENTS](state, totalAttachments) {
        state.totalAttachments = totalAttachments
    },
    [types.SET_SELECT_ALL_STATE](state, data) {
        state.selectAllField = data
    },
    [types.SET_SELECTED_ATTACHMENTS](state, data) {
        state.selectedAttachments = data
    },
 //invoice Attachment data
  [types.PREAPPROVED_INVOICE_ATTACHMENTS] (state, attachments) {
    state.preapprovedInvoiceAttachments = attachments
  },
  [types.SET_TOTAL_PREAPPROVED_INVOICE_ATTACHMENTS] (state, totalAttachments) {
    state.preapprovedInvoiceTotalAttachments = totalAttachments
  },
  [types.SET_SELECTED_PREAPPROVED_INVOICE_ATTACHMENTS] (state, data) {
    state.preapprovedInvoiceSelectAllField = data
  },
  [types.SET_SELECT_ALL_PREAPPROVED_INVOICE_STATE] (state, data) {
    state.preapprovedInvoiceSelectedAttachments = data
  },

    //prepayment attchment data
    [types.BOOTSTRAP_PREPAYMENT_DOCUMENTTYPES](state, documentTypes) {
        state.prepaymentDocumentTypes = documentTypes
    },
    [types.PREPAYMENT_ATTACHMENTS](state, prepaymentAttachments) {
        state.prepaymentAttachments = prepaymentAttachments
    },
    [types.SET_TOTAL_PREPAYMENT_ATTACHMENTS](state, prepaymentTotalAttachments) {
        state.prepaymentTotalAttachments = prepaymentTotalAttachments
    },
    [types.SET_SELECT_ALL_PREPAYMENT_STATE](state, data) {
        state.selectAllFieldPrepayment = data
    },
    [types.SET_SELECTED_PREPAYMENT_ATTACHMENTS](state, data) {
        state.selectedPrepaymentAttachments = data
    },

    //profile attchment data
    [types.BOOTSTRAP_PROFILE_DOCUMENTTYPES](state, profileDocumentTypes) {
        state.profileDocumentTypes = profileDocumentTypes
    },
    [types.PROFILE_DOCUMENTS](state, profileDocuments) {
        state.profileDocuments = profileDocuments
    },

    //process documents

    [types.PROCESS_DOCUMENTS](state, processDocuments) {
        state.processDocuments = processDocuments
    },

    [types.BOOTSTRAP_PROCESS_DOCUMENTTYPES](state, processDocumentTypes) {
        state.processDocumentTypes = processDocumentTypes
    },

    //PO Attachment data
    [types.BOOTSTRAP_PO_DOCUMENTTYPES](state, PODocumentTypes) {
        state.PODocumentTypes = PODocumentTypes
    },
    [types.PO_ATTACHMENTS](state, POAttachments) {
        state.POAttachments = POAttachments
    },
    [types.SET_TOTAL_PO_ATTACHMENTS](state, totalPOAttachments) {
        state.totalPOAttachments = totalPOAttachments
    },
    [types.SET_SELECT_ALL_PO_STATE](state, data) {
        state.selectAllFieldPO = data
    },
    [types.SET_SELECTED_PO_ATTACHMENTS](state, data) {
        state.selectedPOAttachments = data
    },




}
